import axios from 'axios'
import { getCookie, setCookie } from './utils'
import posthog from 'posthog-js'

const instance = axios.create({
    withCredentials: true,
    baseURL: process.env.NEXT_PUBLIC_API_URL,
})

instance.interceptors.request.use(
    async (config) => {
        try {
            config.headers = {
                Authorization: 'Bearer ' + getCookie('accessToken'),
                RefreshToken: getCookie('refreshToken'),
            }
        } catch (e) {}
        try {
            config.params = { ...config.params, ts: Date.now() }
        } catch (e) {}
        return config
    },
    (error) => Promise.reject(error)
)

instance.interceptors.response.use(
    (response) => {
        try {
            if (response.headers.tokenrefreshed === 'true') {
                if (response.headers.authorization) {
                    setCookie('accessToken', response.headers.authorization.replace('Bearer ', ''))
                } else {
                    setCookie('accessToken', response.headers['x-amzn-remapped-authorization'].replace('Bearer ', ''))
                }
            }
            if (response.headers.refreshtoken) {
                setCookie('refreshToken', response.headers.refreshtoken)
            }
        } catch (e) {}
        try {
            if (response.data.redirect) {
                window.location.href = response.data.redirect
            }
        } catch (e) {}
        try {
            if (response.data.events) {
                response.data.events.forEach((event) => {
                    window.dataLayer.push({ event: event.name, ...event })
                })

                if (!posthog._isIdentified() && response.data.events[0].params.user_id) {
                    posthog.identify(response.data.events[0].params.user_id)
                }
            }
        } catch (e) {}
        return response
    },
    (error) => {
        try {
            if (error.response.data.redirect) {
                window.location.href = error.response.data.redirect
            }
        } catch (e) {}
        try {
            if (response.data.events) {
                response.data.events.forEach((event) => {
                    window.dataLayer.push({ event: event.name, ...event })
                })
            }
        } catch (e) {}
        return Promise.reject(error)
    }
)

export default instance
